import { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { Button, Table, DatePicker, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from "../../tool/axios"
import { SelectStores } from '../../component/common/Selects'
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table

type fetchParams = {
    date: any,
    store_id: undefined | string
}

type pagination = {
    current: number,
    pageSize: number
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        date: null,
        store_id: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8
    })

    // 列表数据
    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    // 权限数据获取
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value
        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.report_date = moment(params.date).format('YYYY-MM')
            delete params.date
        }

        axiosTable.get('/finance_center/business_report/check_in_income/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 财务中心 -> 经营报表 -> 入住收入报表 */}
        <BreadCrumb position={['财务中心', '入住收入报表']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <DatePicker style={{ marginRight: 8, marginBottom: 12 }} placeholder={'选择日期'} picker="month" value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores valueProp="id" value={fetchOtherParams.store_id} onChange={(value: string) => { handleChange(value, 'store_id') }} />
                </div>

                {permission.includes('查询') && <Button style={{ marginRight: 5, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 5, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </Space>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                <Column title="日期" dataIndex="report_date" key="report_date" />
                <Column title="门店" dataIndex="store_name" key="store_name" />
                <Column title="入住人数" dataIndex="total_check_in_count" key="total_check_in_count" />
                <Column title="入住总天数" dataIndex="total_check_in_days" key="total_check_in_days" />
                <Column title="合同总金额" dataIndex="total_agreement_amount" key="total_agreement_amount" />
                <Column title="入住总金额" dataIndex="total_check_in_amount" key="total_check_in_amount" />
                <Column title="间天总金额" dataIndex="total_split_day_amount" key="total_split_day_amount" />
                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />

                {permission.includes('查看') && <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button type="primary" ><Link to={"/check_in_income_detail/" + record.report_check_in_id}>查看</Link></Button>
                        </Space>
                    )}
                />}
            </Table>
        </div>
    </div>)
}